/**
 * Shared v1 profile-card style fragments (server-safe constants — no React).
 * One owner for the card-shell tokens and the dark photo scrim so the hero /
 * listing cards / rail / review cards can't drift (all `--brand-*` tokens,
 * never raw black/white — repo rule).
 */
import type { CSSProperties } from "react";

/** The rounded v1 card shell (bg / border / radius / shadow). */
export const CARD_SHELL_STYLE: CSSProperties = {
  backgroundColor: "var(--brand-card-bg)",
  border: "1px solid var(--brand-card-border)",
  borderRadius: "var(--radius-card, 8px)",
  boxShadow: "var(--shadow-resting)",
};

/** Bottom-up dark scrim behind white overlay text on photos. */
export const PHOTO_SCRIM =
  "linear-gradient(to top, color-mix(in srgb, var(--brand-text) 95%, transparent) 0%, color-mix(in srgb, var(--brand-text) 85%, transparent) 60%, transparent 100%)";
